import { render } from "./TeamingTiptapSlashCommands.vue?vue&type=template&id=3443a373"
import script from "./TeamingTiptapSlashCommands.vue?vue&type=script&lang=js"
export * from "./TeamingTiptapSlashCommands.vue?vue&type=script&lang=js"

import "./TeamingTiptapSlashCommands.vue?vue&type=style&index=0&id=3443a373&lang=scss"
script.render = render

export default script